import {Component} from 'react'
import {
  Header,
  Title,
  TitleContainer,
  ScoreBox,
  ScoreText,
  ScoreValue,
} from './styledComponents'

class ScoreCard extends Component {
  render() {
    const {score} = this.props
    return (
      <Header>
        <TitleContainer>
          <Title>Rock Paper Scissors</Title>
        </TitleContainer>
        <ScoreBox>
          <ScoreText>Score</ScoreText>
          <ScoreValue>{score}</ScoreValue>
        </ScoreBox>
      </Header>
    )
  }
}

export default ScoreCard
